import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { DEFAULT_PRACTICE, setPracticeSnapshot, patchStaticGraph } from '../data/practice';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PracticeContext = createContext({ practice: DEFAULT_PRACTICE, applyPractice: () => {} });

export const PracticeProvider = ({ children }) => {
  const [practice, setPractice] = useState(DEFAULT_PRACTICE);

  const applyPractice = useCallback((next) => {
    const merged = { ...DEFAULT_PRACTICE, ...next };
    setPracticeSnapshot(merged);
    patchStaticGraph(merged);
    setPractice(merged);
  }, []);

  useEffect(() => {
    axios.get(`${API}/practice-details`)
      .then(({ data }) => applyPractice(data))
      .catch(() => { /* keep defaults */ });
  }, [applyPractice]);

  return (
    <PracticeContext.Provider value={{ practice, applyPractice }}>
      {children}
    </PracticeContext.Provider>
  );
};

export const usePractice = () => useContext(PracticeContext).practice;
export const useApplyPractice = () => useContext(PracticeContext).applyPractice;
